import PlainItemsSelector from 'app/common/ui-next/plain-selector/plain-items-selector'
import { sortByTitle } from 'app/common/lib/sort'

import type { SurveyFilterItemProps } from './types'


export const DistrictFilter = ({
  value,
  options,
  loading,
  colorInverse,
  disabled,
  onChange,
}: SurveyFilterItemProps) => {
  const handleChange = (districtIds: Array<string>) => {
    onChange({
      ...value,
      districtIds,
      schoolIds: [],
    })
  }

  return (
    <PlainItemsSelector
      id="surveyDistrict"
      label="Район"
      header="Выбор района"
      sortFunc={sortByTitle}
      selection={value.districtIds}
      items={options.districts}
      multiple
      colorInverse={colorInverse}
      disabled={loading || !value.cityIds.length || disabled}
      onChange={handleChange}
      selectedAllOnEmptySelection
      skipUpperSpace
      disableAutoSelect
      doOnBadgeCrossClick="clear"
      maxViewCountBadge={3}
    />
  )
}
